import {
  ENUM_VERSIONS_LIST,
  ENUM_VERSIONS_LIST_SUCCESS,
  ENUM_VERSIONS_LIST_ERROR,
} from "./actionTypes"


export const enumVersionsList = data => ({
  type: ENUM_VERSIONS_LIST,
  payload: data
});

export const enumVersionsListSuccess = data => ({
  type: ENUM_VERSIONS_LIST_SUCCESS,
  payload: {data}
});

export const enumVersionsListError = error => ({
  type: ENUM_VERSIONS_LIST_ERROR,
  payload: error,
});
